export default class LoanApiService {
    _baseUrl = '/api/v1/payment/';

    getResource = async (url, method, data, token) => {
        let config = {};
        if (method === 'post' || method === 'put') {
            config =
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    method: method,
                    body: JSON.stringify(data)
                };
        } else {
            config =
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    method: 'get'
                };
        }
        if (token) {
            config.headers['Authorization'] = token;
        }
        const res = await fetch(`${this._baseUrl}${url}`, config);

        return res;
    }

    sendSms = async (iin) => {
        const res = await this.getResource('send-sms/' + iin, 'get');
        return await res.json()
    }
    checkSms = async (verificationId, smsCode) => {
        const res = await this.getResource('check-sms/' + verificationId + '/' + smsCode, 'get');
        return await res.json()
    }
    loanInfo = async (token) => {
        const res = await this.getResource('loans-info', 'get',null,'Bearer '+token);
        if (!res.ok) {
            throw Error(res.statusText);
        }
        return await res.json()
    }
    createPayment = async (token,{tdid,uuid,pkey,successUrl,failureUrl}) => {
        const postData = {
            tdid,
            uuid,
            paymentKey:pkey,
            successUrl,
            failureUrl
        }
        const res = await this.getResource('create-payment','post',postData ,'Bearer '+token);
        if (!res.ok) {
            throw Error(res.statusText);
        }
        return await res.json()
    }
}